export default __webpack_public_path__ + "static/media/bg.bdb52cc6.jpg";